import data from './datasets.js'

export default str => data.filter(d => d.name.toLowerCase().indexOf(str) > -1 || d.plz.indexOf(str) === 0)



// WEBPACK FOOTER //
// ./src/data/search.js